__turbopack_context__.v({
  "root": "spinner-module-scss-module__BOkkiq__root",
  "spin": "spinner-module-scss-module__BOkkiq__spin",
});
